import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faCaretDown,
  faCaretUp,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';
import {
  Nav,
  Image,
  Button,
  Modal
} from '@themesberg/react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/auth';
import { Routes } from '../../routes';
import ReactHero from '../../assets/img/state-govt-logo.png';
import ProfilePicture from '../../assets/img/default_avatar.png';
import { mainTreasuryModules } from '../../pages/examples/user-admin/modules';

const MobileSidebar = ({ show, onHide, user }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openDropdowns, setOpenDropdowns] = useState([]);

  const handleLogout = () => {
    dispatch(logout(() => navigate(Routes.Signin.path)));
    onHide();
  };

  const handleNavigation = (path) => {
    navigate(path);
    onHide();
  };

  const CollapsableNavItem = ({ eventKey, title, icon, children = null }) => {
    const isDropdownOpen = openDropdowns.includes(eventKey);

    const handleDropdownToggle = (eventKey) => {
      const index = openDropdowns.indexOf(eventKey);
      if (index === -1) {
        setOpenDropdowns([eventKey]);
      } else {
        setOpenDropdowns([]);
      }
    };

    return (
      <div className="mb-2">
        <div
          className="d-flex justify-content-between align-items-center p-3 bg-light rounded"
          onClick={() => handleDropdownToggle(eventKey)}
          style={{ cursor: 'pointer' }}
        >
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon={icon} className="me-3 text-primary" />
            <span className="fw-semibold">{title}</span>
          </div>
          <FontAwesomeIcon
            icon={isDropdownOpen ? faCaretUp : faCaretDown}
            className="text-muted"
          />
        </div>
        
        {isDropdownOpen && (
          <div className="mt-2 ps-4">
            {children}
          </div>
        )}
      </div>
    );
  };

  const NavItem = ({ title, link, icon }) => {
    return (
      <div
        className="d-flex align-items-center p-2 mb-1 rounded hover-bg-light"
        onClick={() => handleNavigation(link)}
        style={{ cursor: 'pointer' }}
      >
        <FontAwesomeIcon icon={icon} className="me-3 text-secondary" size="sm" />
        <span>{title}</span>
      </div>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="mobile-sidebar-modal"
      contentClassName="mobile-sidebar-content"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="bg-primary text-white border-0">
        <div className="d-flex align-items-center">
          <Image
            src={ReactHero}
            height={40}
            width={40}
            className="me-3"
          />
          <Modal.Title className="fw-bold">KIFMIS</Modal.Title>
        </div>
        <Button
          variant="link"
          className="text-white p-0 border-0"
          onClick={onHide}
          style={{ boxShadow: 'none' }}
        >
          <FontAwesomeIcon icon={faTimes} size="lg" />
        </Button>
      </Modal.Header>

      <Modal.Body className="p-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {/* User Info */}
        <div className="p-3 bg-light border-bottom">
          <div className="d-flex align-items-center">
            <Image
              src={ProfilePicture}
              className="rounded-circle me-3"
              width="40"
              height="40"
            />
            <div>
              <h6 className="mb-0">Hi, {user?.username}</h6>
              <small className="text-muted">{user?.mda_name}</small>
            </div>
          </div>
        </div>

        {/* Navigation Menu */}
        <div className="p-3">
          {mainTreasuryModules.map((module, index) => {
            const modKey = module.title.split(" ").join("-");
            
            if (module.subMenu && module.subMenu.length) {
              if (user?.accessTo && user.accessTo.includes(module.title)) {
                return (
                  <CollapsableNavItem
                    key={index}
                    eventKey={modKey}
                    title={module.title}
                    icon={module.icon}
                  >
                    {module.subMenu.map((item, idx) => {
                      if (
                        user?.functionalities &&
                        user.functionalities.includes(item.title)
                      ) {
                        const itemKey = `${modKey}-${idx}-${item.title.split(" ").join("-")}`;
                        return (
                          <NavItem
                            key={itemKey}
                            title={item.title}
                            link={item.route}
                            icon={item.icon}
                          />
                        );
                      }
                      return null;
                    })}
                  </CollapsableNavItem>
                );
              }
            } else {
              if (user?.accessTo && user.accessTo.includes(module.title)) {
                return (
                  <div key={index} className="mb-2">
                    <NavItem
                      title={module.title}
                      link={module.route}
                      icon={module.icon}
                    />
                  </div>
                );
              }
            }
            return null;
          })}
        </div>
      </Modal.Body>

      <Modal.Footer className="border-top">
        <Button
          variant="outline-danger"
          className="w-100"
          onClick={handleLogout}
        >
          <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
          Sign Out
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MobileSidebar;